import { render, staticRenderFns } from "./ListProductsModal.vue?vue&type=template&id=018cfdd1&scoped=true"
import script from "./ListProductsModal.vue?vue&type=script&lang=js"
export * from "./ListProductsModal.vue?vue&type=script&lang=js"
import style0 from "./ListProductsModal.vue?vue&type=style&index=0&id=018cfdd1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "018cfdd1",
  null
  
)

export default component.exports